export default function useSearchAirports(options = {}) {
    return ReactQuery.useQuery({
        queryKey: ['search', 'airports'],
        queryFn: ({ signal }) => requestAction.initData(true, MAX_AIRPORTS, signal)
            .then(response => response.airports),
        initialData: [],
        ...options,
    })

}
